import React from 'react';

const ExtraIcon = () => {
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.00033 13.3915L14.1503 16.4998L12.7837 10.6415L17.3337 6.69984L11.342 6.1915L9.00033 0.666504L6.65866 6.1915L0.666992 6.69984L5.21699 10.6415L3.85033 16.4998L9.00033 13.3915Z" fill="currentColor"/>
    </svg>
  )
}

export default ExtraIcon;